import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { dataCategorie } from 'src/app/generales/login/pages/perfil/interfaces-perfil/interfacesPerfil';
import { EditCategorieComponent } from '../edit-categorie/edit-categorie.component';
import { AdminServiceService } from '../../service/admin-service.service';
import { LoadingService } from '../../../generales/services/loading.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  public title = 'Categorias';
  public categories: dataCategorie[] = [];
  public page = 1;
  public totalPages = 0;
  public search = '';
  
  constructor(
    private adminService: AdminServiceService,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private loadingService: LoadingService
  ) {}
  
  ngOnInit() {
    this.getCategories();
  }

  async getCategories() {
    const params = {
      pag: this.page,
      search: this.search
    }

    const res: any = await this.adminService.getAllCategories('index', params);
    this.totalPages = res.data.meta.last_page || 1;

    this.categories = res.data.data;
  }

  setSearch(ev){
    this.search = ev.value;
    this.page = 1;
    this.getCategories();
  }

  changePage(ev){
    this.page = ev;
    this.getCategories();
  }

  async edit(categorie = {}) {
    const editCategorie = await this.modalCtrl.create({
      component: EditCategorieComponent,
      componentProps: { categorie },
    });

    await editCategorie.present();
    editCategorie.onWillDismiss().then((res) => this.getCategories());
  }

  async deleteCategorie(id) {
    const data = {
      id: id,
    };
    const deleteProduct = await this.alertCtrl.create({
      header: 'Eliminar',
      message: `¿Deseas eliminar la categoria ${id}?`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Aceptar',
          handler: () => {
            this.loadingService.show();
            this.adminService.deleteCategorie(data).subscribe((res) => {
              console.log(res);
              this.getCategories();
              this.loadingService.hide();
            });
          },
        },
      ],
    });

    deleteProduct.present();
  }
}
